import { render } from "./RadicalCard.vue?vue&type=template&id=55d47746"
import script from "./RadicalCard.vue?vue&type=script&lang=js"
export * from "./RadicalCard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\cram_srs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__